import { render, staticRenderFns } from "./PushNotificationForm.vue?vue&type=template&id=0648d59c&"
import script from "./PushNotificationForm.vue?vue&type=script&lang=js&"
export * from "./PushNotificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports